import { object, SchemaOf, string } from "yup";
import { FC } from "react";
import { FormField } from "@epcnetwork/core-ui-kit";

import { requiredFieldText } from "constants/form.constants";

export const omnisendSchema: SchemaOf<OmnisendType> = object({
  apiKey: string().required(requiredFieldText),
});

export type OmnisendType = {
  apiKey: string;
};

type OmnisendProps = {
  endpointOrdinal: number;
};

const Omnisend: FC<OmnisendProps> = ({ endpointOrdinal }) => {
  return (
    <>
      <FormField
        type="text"
        name={`endpoints[${endpointOrdinal}].connector.properties.apiKey`}
        label="Api Key"
        placeholder="Api Key"
      />
    </>
  );
};

export { Omnisend };
